// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../common/temp/default/node_modules/.pnpm/@rsbuild+core@1.1.13/node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../common/temp/default/node_modules/.pnpm/@rsbuild+core@1.1.13/node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.guide-modal-b9A_Ip .semi-modal-content{padding-bottom:0!important;padding-left:0!important;padding-right:0!important}.guide-modal-b9A_Ip .semi-modal-header{padding-left:24px;padding-right:24px}.guide-modal-b9A_Ip .semi-modal-footer{display:none}.guide-button-ITDa4v{box-shadow:inset -8px -18px 30px #dae6f7}.guide-button-hover-STnRMj:hover .guide-img-bg-MlDr_1{background:linear-gradient(29deg,rgba(79,62,255,.17) 15.59%,rgba(242,146,255,.14) 42.22%,rgba(242,146,255,0) 72.41%),var(--coz-bg-primary,#f8f8fc)}.guide-button-hover-STnRMj:hover .guide-desc-hover-TgyIt6{opacity:0}.guide-button-hover-STnRMj:hover .create-button-hover-Hr9VLV{opacity:1}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"guide-modal": `guide-modal-b9A_Ip`,
	"guideModal": `guide-modal-b9A_Ip`,
	"guide-button": `guide-button-ITDa4v`,
	"guideButton": `guide-button-ITDa4v`,
	"guide-button-hover": `guide-button-hover-STnRMj`,
	"guideButtonHover": `guide-button-hover-STnRMj`,
	"guide-img-bg": `guide-img-bg-MlDr_1`,
	"guideImgBg": `guide-img-bg-MlDr_1`,
	"guide-desc-hover": `guide-desc-hover-TgyIt6`,
	"guideDescHover": `guide-desc-hover-TgyIt6`,
	"create-button-hover": `create-button-hover-Hr9VLV`,
	"createButtonHover": `create-button-hover-Hr9VLV`
};
export default ___CSS_LOADER_EXPORT___;
